namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoApDtForm {
        ItemType: Serenity.EnumEditor;
        ItemCode: Serenity.StringEditor;
        PromoType: Serenity.EnumEditor;
        PromoDiscPc: Serenity.DecimalEditor;
        GroupCode1: Serenity.StringEditor;
        DescItem: Serenity.StringEditor;
        PromoPrice: Serenity.DecimalEditor;
        GpNormal: Serenity.DecimalEditor;
        GpPromo: Serenity.DecimalEditor;
    }

    export class PsPromoApDtForm extends Serenity.PrefixedContext {
        static formKey = 'SalePromoCamp.PsPromoApDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPromoApDtForm.init)  {
                PsPromoApDtForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(PsPromoApDtForm, [
                    'ItemType', w0,
                    'ItemCode', w1,
                    'PromoType', w0,
                    'PromoDiscPc', w2,
                    'GroupCode1', w1,
                    'DescItem', w1,
                    'PromoPrice', w2,
                    'GpNormal', w2,
                    'GpPromo', w2
                ]);
            }
        }
    }
}
